import { CloudSyncOutlined } from '@ant-design/icons';
import { Tag } from 'antd';
import { type IntlShape, useIntl } from 'react-intl';
import { FIELD_AUTO_SYNC_STATUSES, type FieldAutoSyncStatus } from '@/features/sync/engine/field-auto-sync';
import { messages } from './messages';

export function AutoSyncStatusTag({ status }: { status: FieldAutoSyncStatus }) {
  const intl = useIntl();

  return (
    <Tag color={getAutoSyncTagColor(status)} icon={<CloudSyncOutlined />}>
      {formatAutoSyncStatus(intl, status)}
    </Tag>
  );
}

function formatAutoSyncStatus(intl: IntlShape, status: FieldAutoSyncStatus) {
  switch (status) {
    case FIELD_AUTO_SYNC_STATUSES.disabled:
      return intl.formatMessage(messages.autoSyncOff);
    case FIELD_AUTO_SYNC_STATUSES.running:
      return intl.formatMessage(messages.autoSyncRunning);
    case FIELD_AUTO_SYNC_STATUSES.failed:
      return intl.formatMessage(messages.autoSyncFailed);
    default:
      return intl.formatMessage(messages.autoSyncOn);
  }
}

function getAutoSyncTagColor(status: FieldAutoSyncStatus) {
  switch (status) {
    case FIELD_AUTO_SYNC_STATUSES.failed:
      return 'red';
    case FIELD_AUTO_SYNC_STATUSES.running:
      return 'processing';
    case FIELD_AUTO_SYNC_STATUSES.disabled:
      return 'default';
    default:
      return 'green';
  }
}
